import { render, staticRenderFns } from "./EditTests.vue?vue&type=template&id=85524bd8"
import script from "./EditTests.vue?vue&type=script&lang=js"
export * from "./EditTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports